import axios from 'axios';

const API_BASE_URL = `${global.config.apiDomain}/rest/manage-vietcombank`;
const GET_TRANSACTION_URL = `${global.config.apiDomain}/mc-user/web/bank/get-transaction`;
const GET_BANK_ACCOUNTS_URL = `${global.config.apiDomain}/mc-user/web/bank/get-accounts`;
const CREATE_OR_UPDATE_ACCOUNT_URL = `${global.config.apiDomain}/mc-user/web/bank/upsert`;
const DELETE_ACCOUNT_URL = `${global.config.apiDomain}/mc-user/web/bank/delete`;
const UPDATE_ACCOUNT_STATUS_URL = `${global.config.apiDomain}/mc-user/web/bank/update-status`;
// const DELETE_ACCOUNTS_URL = `${global.config.apiDomain}/mc-user/web/vcb/delete`;

const headers = {
  "Content-Type": "application/json"
};

const handleResponse = (response) => {
  if (!response.data) {
    throw new Error('No data received from server');
  }
  return response.data;
};

const handleError = (error) => {
  const message = error.response?.data?.message || error.message || 'An error occurred';
  throw new Error(message);
};

export const vietcomBankService = {
  getAccounts: async () => {
    try {
      const response = await axios.get(
        `${GET_BANK_ACCOUNTS_URL}`,
        {},
        { headers }
      );
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  createOrUpdateAccount: async (accountData) => {
    try {
      if (
        !accountData.accountNumber ||
        !accountData.username ||
        !accountData.bankName ||
        accountData.minLevel === undefined ||
        accountData.minLevel === null ||
        accountData.maxLevel === undefined ||
        accountData.maxLevel === null
      ) {
        throw new Error('Missing required fields');
      }
      const response = await axios.post(
        `${CREATE_OR_UPDATE_ACCOUNT_URL}`,
        accountData,
        { headers }
      );
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  deleteAccount: async (accountId) => {
    try {
      if (!accountId) {
        throw new Error('Account ID is required');
      }
      const response = await axios.post(
        `${API_BASE_URL}/delete`,
        { id: accountId },
        { headers }
      );
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  deleteAccounts: async (accountIds) => {
    try {
      if (!accountIds || accountIds.length === 0) {
        throw new Error('Account IDs are required');
      }
      const response = await axios.post(
        `${DELETE_ACCOUNT_URL}`,
        { ids: accountIds },
        { headers }
      );
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  getTransactions: async (accountId) => {
    try {
      const response = await axios.get(
        `${GET_TRANSACTION_URL}?id=${accountId}`,
        {},
        { headers }
      );
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  updateAccountStatus: async (id, status) => {
    try {
      if (!id) {
        throw new Error('Account ID is required');
      }
      const response = await axios.post(
        `${UPDATE_ACCOUNT_STATUS_URL}`,
        { id, status },
        { headers }
      );
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  }
}; 